module.exports = __webpack_public_path__ + "static/media/courses2.b379042a.png";